<template>
    <div></div>
</template>

<script>
    import { getRouter } from "@/bridge/var";
    import { getLoginType } from '@/libs/until'
    export default {
        name: "homeInterim",
        data(){
            return{
                logintype: getLoginType(),
            }
        },
        created(){
            getRouter().then(result => {
                this.$router.options.routes = result.router;
                this.$router.addRoutes(result.router);
                this.$store.commit('setRouter', result);
            })
            if(this.logintype=='HCM'|| this.logintype=='HCMSUB') {
                this.$router.replace({path:'/BrandHomepage'})
            }
            else if(this.logintype=='ADMIN') {
                this.$router.replace({path:'/adminHomepage'})
            } else if (this.logintype=='KEFU') {
                this.$router.replace({path:'/BrmHomepage'})
            }else if (this.logintype=='DEALER'||this.logintype=='SHOP'){
                this.$router.replace({path:'/Dealers'})
            }
            else {
                this.$router.push({path:'/home'})
            }
        },

    }
</script>

<style scoped>

</style>
